/**
* directives.macros Module
*
* Description
*/
var app = angular.module('directives.macros');
    app.directive('macros', [
            '$compile',
            '$filter',
            '$timeout',
            function ($compile, $filter, $timeout) {
                return {
                    require: '^ngModel',
                    scope: {
                        readonly: "=ngReadonly",
                        value: '=ngModel',
                        fields: '=fields'
                    },
                    controller: ['$scope',function ($scope) {}],
                    link: macrosLink
                };

                function macrosLink (scope, element, attr, ngModelCtrl) {

                    function init () {
                        var str = scope.value.replace((/\{\{/g), '[[').replace((/\}\}/g), ']]');
                        for (var i = 0; i < scope.fields.length; i++) {
                                var fieldNameRegExp = new RegExp('\\[\\[' + scope.fields[i].alias + '\\]\\]');
                                if (str.search(fieldNameRegExp) !== -1) {
                                    str = str.replace(fieldNameRegExp, '{{fields[' + i + '].value}}');
                                }
                        }
                        element.html($compile('<texparea class="mac">' + str + '</texparea>')(scope));
                    }

                    scope.updateModel = function () {
                        $timeout(function () {
                            ngModelCtrl.$setViewValue($.trim(element.text()));
                        });
                    };

                    scope.$watch('fields', function (fields) {
                        scope.updateModel();
                    }, true);

                    init ();
                }
            }
        ]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/macrosAttr/macrosAttr.directive.js
 ** module id = 177
 ** module chunks = 1
 **/